import { createRoot } from 'react-dom/client';
import App from './App';
import './assets/scss/index.scss';
import 'react-photo-view/dist/react-photo-view.css';
import "react-multi-carousel/lib/styles.css";
import './shared/i18n/config';
const container = document.getElementById('root');
const root = createRoot(container!); // createRoot(container!) if you use TypeScript
root.render(<App />);
